define('views/modules/calendar/calendar/calendar',[
    // Libs
    'underscore', 'backbone', 'mustache', 'moment', 'utils', 'html2pdf',
    // views
    'views/modules/calendar/calendar/calendar-component/calendar-component',
    'views/modules/calendar/calendar/summary/summary',
    'views/parts/menu/menu',
    'views/modules/calendar/calendar/filter/filter',
    'views/parts/form/select',
    'views/parts/form/button',
    // services
    'services/user',
    // events
    'services/events/calendar-events',
    // Templates
    'text!templates/modules/calendar/calendar/calendar.html',
], function(
    // libs
    _, Backbone, Mustache, moment, U, html2pdf,
    // views
    VCalendarComponent,
    VSummary,
    VMenu,
    VFilter,
    VSelect,
    VButton,
    // services
    User,
    // events
    CalendarEvents,
    // templates
    TCalendar
) {

    var VCalendar = Backbone.Epoxy.View.extend({
        template: TCalendar,
        title: function() {
            return Mustache.render('calendar:Calendar', Mustache.getContext());
        },

        subtitle: 'calendar:calendar-subtitle',

        events: {
            // date range
            "click #calendar-date-from-toggle": "toggleDateFrom", // calendar icon fix
            "click #calendar-date-to-toggle": "toggleDateTo",
            "hide #calendar-date-from": "onDateFromPicked",
            "hide #calendar-date-to": "onDateToPicked",
            // display mode
            "click .button-calendar": "onDisplayCalendarClick",
            "click .button-list": "onDisplayListClick",
            // additionnal info
            "click .button-summary": "onDisplaySummaryClick",
            "click .button-filter": "onDisplayFilterClick",
            // print
            "click .button-print": "onPrintCalendarClick",
        },

        regions: {
            from: "#calendar-date-from",
            to: "#calendar-date-to",
            calendar: '.calendar-component',
            summary: ".summary-container",
            filter: ".filters-container",
            button: {
                root: ".calendar-view-button",
                templateManage: '.btn-manage-template'
            },
        },

        initialize: function(options) {
            options = this.options = new Backbone.Model(_.extend({
                weeks: 4,
                filter: false,
                summary: false,
                toolButton: true,
            }, this.defaults, _.omit(options, 'model')));

            if (options.has('url')) this.setUrl("root", "#/" + options.get('url'));

            var listDisplay = this.listDisplayOptions = new Backbone.Model({
                listDisplay: false,
                manualListDisplay: false,
                forcedListDisplay: false,
            });

            this.role = options.get('role');
            this.bindingSources = { options: options, listDisplay: listDisplay };

            // setup datepicker
            this.datePickerOptions = {
                autoclose: true,
                todayHighlight: true,
            };

            // default dates
            var start = moment().startOf('isoWeek');//.subtract(1, 'w');
            this.dates = new Backbone.Model({
                from: start,
                to: moment(start).add(options.get('weeks') * 7 - 1, 'days')
            });

            this.listenTo(listDisplay, { 'change:forcedListDisplay': this.onForcedListDisplayChange });
            this.listenTo(CalendarEvents, 'calendar:daysBeforeCalendarItemsAreHiddenChange', this.onDaysBeforeCalendarItemsAreHiddenChangedChange);

            this.view = {};
        },

        render: function() {
            // Render HTML template
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(_.extend(this.options.toJSON(), {
                isSupervisor: this.role === 'supervisor'
            }))));

            this.applyBindings();
            this.generateZones();

            var zone = this.zone;
            // make a date range picker
            this.$('.input-daterange').datepicker(this.datePickerOptions);

            // set default if not set
            var dates = this.dates;
            zone.$from.datepicker("setDate", dates.get('from').toDate());
            zone.$to.datepicker("setDate", dates.get('to').toDate());

            // assigning calendar parts
            this._renderCalendar()
                ._renderSummary()
                ._renderFilter()
                ._renderTemplateAssignButton();

            return this;
        },

        onWeekChange: function(model, options) {
            var weekCount = model.get('value'),
                to = moment(this.dates.get('from')).add((weekCount - 1) * 7, 'days');

            this.setTo(to);
            this.view.calendar.loadCalendar();
        },

        _renderCalendar: function() {
            var view = this.view,
                calendar = view.calendar;
            if (!calendar) {
                calendar = view.calendar = new VCalendarComponent({
                    profile: this.model,
                    dates: this.dates,
                    url: this.url,
                    role: this.role,
                    listDisplayOptions: this.listDisplayOptions
                });
            }

            this.assign(calendar, this.zone.$calendar);
            return this;
        },

        _renderSummary: function() {
            var summary = this.view.summary;
            if (summary) this.assign(summary, this.zone.$summary);
            return this;
        },

        _renderFilter: function() {
            var filter = this.view.filter;
            if (filter) this.assign(filter, this.zone.$filter);
            return this;
        },

        _renderTemplateAssignButton: function() {
            var view = this.view,
                button = view.templateAssign || (view.templateAssign = new VButton({
                    label: "calendar:Manage template assignments",
                    callback: this.onManageTemplateClick,
                    icon: "sl-icon-organization",
                    class: "btn-tc-white",
                    tcClass: false,
                    context: this,
                }));
            this.assign(button, this.zone.button.$templateManage);
            return this;
        },

        ////////////////////
        // dates handling //
        ////////////////////
        toggleDateFrom: function(e) {
            this.zone.$from.datepicker('show');
        },

        toggleDateTo: function(e) {
            this.zone.$to.datepicker('show');
        },

        setFrom: function(newFrom) {
            var fromDate = moment(newFrom).startOf('isoWeek'),
                dates = this.dates;
            dates.set({ from: fromDate });
            // prevent impossible range
            if (dates.get('to').isBefore(fromDate, 'day')) {
                this.setTo(fromDate);
            }
            // updte the date picker value
            this.zone.$from.datepicker("setDate", fromDate.toDate());
        },

        setTo: function(newTo) {
            var toDate = moment(newTo).endOf('isoWeek'),
                dates = this.dates;
            dates.set({ to: toDate });
            // prevent impossible range
            if (dates.get('from').isAfter(dates.get('to'), 'day')) {
                this.setFrom(toDate);
            }
            // updte the date picker value
            this.zone.$to.datepicker("setDate", toDate.toDate());
        },

        /** only triggers when the from date is picked from the UI by the user */
        onDateFromPicked: function(e) {
            var dates = this.dates,
                oldDate = dates.get('from');

            this.setFrom(e.date);
            if (!dates.get('from').isSame(oldDate, 'day')) {
                this.view.calendar.loadCalendar();
            }
        },
        /** only triggers when the to date is picked from the UI by the user */
        onDateToPicked: function(e) {
            var dates = this.dates,
                oldDate = dates.get('to');
            this.setTo(e.date);

            if (!dates.get('to').isSame(oldDate, 'day')) {
                this.view.calendar.loadCalendar();
            }
        },

        //////////////////
        // list display //
        //////////////////

        onDisplayListClick: function(e) {
            this.listDisplayOptions.set('manualListDisplay', true);
        },
        onDisplayCalendarClick: function(e) {
            this.listDisplayOptions.set('manualListDisplay', false);
        },

        onForcedListDisplayChange: function(model, value, options) {
            if (!this.zone) return;
            this.zone.button.$root.toggle(!Boolean(value));
        },

        onDisplaySummaryClick: function(e) {
            var view = this.view,
                summary = view.summary;
            if (!summary) {
                summary = view.summary = new VSummary({ model: this.model });
                this._renderSummary();
            }
            this.options.toggle('summary');
        },

        onDisplayFilterClick: function(e) {
            var view = this.view,
                filter = view.filter;
            if (!filter) {
                filter = view.filter = new VFilter({
                    model: this.model,
                    parent: this,
                });
                this.listenTo(filter, 'filter:click', this.onFilterClick);
                this._renderFilter();
            }
            this.options.toggle('filter');
        },

        onPrintCalendarClick: function(e) {
            html2pdf(this.zone.$calendar[0], {
              margin: 1,
              filename: 'myfile.pdf',
              image: { type: 'jpeg', quality: 0.98 },
              html2canvas: { dpi: 192, letterRendering: true },
              jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            });
        },

        onFilterClick: function(item) {
            var filter = item.get('filter'),
                typeSelector = '.type-' + filter;

            if (filter === "incomplete") {
                typeSelector = ".calendar-item:not(.completed)";
            }

            if (filter === "completed") {
                typeSelector = ".completed";
            }
            // For custom datas filters
            if (item.get('id')) {
                typeSelector += '-' + item.get('id');
            }

            var calendarBody = this.view.calendar.zone.$body;
            calendarBody.find(typeSelector).toggleClass("hide-" + filter, !item.get('active'));
        },

        onManageTemplateClick: function() {
            Backbone.history.navigate(Mustache.render(this.url.root + '{{today}}/template/manage/', {
                today: moment().format('YYYY-MM-DD')
            }), { trigger: true });
        },

        onResize: function(e) {
            var view = this.view.calendar;
            if (view.onResize) view.onResize(e);
        },

        onDaysBeforeCalendarItemsAreHiddenChangedChange: function() {
            this.render();
        }

    });

    return VCalendar;
});

